import { Injectable }          from '@angular/core';
import { AngularFirestore,AngularFirestoreCollection } from '@angular/fire/firestore';

import { AngularFireMessaging } from '@angular/fire/messaging';

import 'rxjs/add/operator/take';
import { mergeMapTo } from 'rxjs/operators';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';

import { PushNotificationsService} from './push.notification.service';

@Injectable()
export class MessagingService {

	public currentMessage = new BehaviorSubject(null);


	constructor(private afs:AngularFirestore,
		private notification:PushNotificationsService,
		private messaging:AngularFireMessaging) {
			

	}
	
	
	
	updateToken(token) {
		if(localStorage.getItem('fcm_keyToken')===null){
			localStorage.setItem('fcm_keyToken', this.afs.createId() ) ;
				
			this.afs.collection('/fcmTokens/').doc(localStorage.getItem('fcm_keyToken')).set({token:token});
		}
		this.afs.doc(`/fcmTokens/${localStorage.getItem('fcm_keyToken')}/`).update({token:token});
	}
	
	
	

	getPermission() {
      this.messaging.requestPermission.pipe(mergeMapTo(this.messaging.tokenChanges))
      .subscribe(
        (token) => { this.updateToken(token);
		//console.log('Permission granted! Save to the server!', token);
		},
        (error) => { console.error(error); },  
      );
    }

    /*receiveMessage() {
       this.messaging.onMessage((payload) => {
        console.log("Message received. ", payload);
        this.currentMessage.next(payload)
      });

    }*/
}